module.exports = __webpack_public_path__ + "img/tornado.5ad69cf4.png";